/* eslint-disable react/no-array-index-key, react/no-danger */
import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap";
import axios from "axiosClient";
import { useUser } from "auth/useUser";
import { useToken } from "auth/useToken";
import { useOptions } from "utils/optionsContext";
import PDFViewContainer from "components/Mock/PDFViewContainer";
import { pdfjs, Document, Page } from "react-pdf";
import { Link, useNavigate, useParams } from "react-router-dom";

const TKTMockPage = (props) => {
  const user = useUser();
  const params = useParams();
  const [token, setToken] = useToken();
  const [data, setData] = useState(null);
  // const [selectedOption, setSelectedOption] = useState(
  //   Array.from({ length: numQuestions }, (_, index) => ({
  //     [index]: null,
  //   })).reduce((acc, obj) => ({ ...acc, ...obj }), {})
  // );
  const { selectedOptions, handleOptionSelect } = useOptions();
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [isStarted, setIsStarted] = useState(false);

  const [questions, setQuestions] = useState([...Array(80)]);
  const [options, setOptions] = useState([..."ABCDEFGHI"]);
  const [finished, setFinished] = useState(false);
  const [band, setBand] = useState(null);
  const [score, setScore] = useState(null);

  const [timeLeft, setTimeLeft] = useState(80 * 60); // 80 minutes in seconds
  const [isRunning, setIsRunning] = useState(false);
  const [isPaused, setIsPaused] = useState(false);
  const timerRef = useRef(null);
  const navigate = useNavigate();

  const id = params.id;
  // const id = "66c30bba4d4d8ab55e5c3e0f";

  // Start the timer
  const startTimer = () => {
    if (isRunning) return;
    setIsRunning(true);
    setIsPaused(false);
    timerRef.current = setInterval(() => {
      setTimeLeft((prevTime) => {
        if (prevTime <= 1) {
          clearInterval(timerRef.current);
          if (!finished) {
            handleSubmit();
          }
          return 0;
        }
        return prevTime - 1;
      });
    }, 1000);
  };

  // Pause the timer
  const pauseTimer = () => {
    if (!isRunning || isPaused) return;
    setIsPaused(true);
    clearInterval(timerRef.current);
  };

  // Resume the timer
  const resumeTimer = () => {
    if (!isRunning || !isPaused) return;
    setIsPaused(false);
    timerRef.current = setInterval(() => {
      setTimeLeft((prevTime) => {
        if (prevTime <= 1) {
          clearInterval(timerRef.current);
          handleSubmit();
          return 0;
        }
        return prevTime - 1;
      });
    }, 1000);
  };

  // Format the time left
  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes}:${secs < 10 ? "0" : ""}${secs}`;
  };

  const handleSubmit = async () => {
    // console.log(selectedOptions);
    let response = await axios.post("/api/test-check", {
      answers: selectedOptions,
      id,
      userId: user.user._id,
    });
    if (response.status === 200) {
      console.log(response.data);
      setFinished(true);
      setBand(response.data.band);
      setScore(response.data.score);
    }
    setIsRunning(false);
    // setTimeLeft(0);
  };

  useEffect(() => {
    axios
      .get(`/api/mock-test/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        setData(res.data.item);
      });
    // console.log(exams);
  }, []);

  useEffect(() => {
    return () => clearInterval(timerRef.current);
  }, []);

  // Disable outer scroll when component mounts
  useEffect(() => {
    // Save the original overflow style
    const originalOverflow = document.body.style.overflow;
    // Disable scroll
    document.body.style.overflow = "hidden";

    // Cleanup on component unmount
    return () => {
      document.body.style.overflow = originalOverflow;
    };
  }, []);

  useEffect(() => {
    // Function to check if the document is in fullscreen
    const handleFullscreenChange = () => {
      setIsFullscreen(
        document.fullscreenElement ||
          document.mozFullScreenElement ||
          document.webkitFullscreenElement ||
          document.msFullscreenElement
      );
    };

    // Add event listener for fullscreen change
    document.addEventListener("fullscreenchange", handleFullscreenChange);
    document.addEventListener("mozfullscreenchange", handleFullscreenChange); // Firefox
    document.addEventListener("webkitfullscreenchange", handleFullscreenChange); // Chrome, Safari, Opera
    document.addEventListener("MSFullscreenChange", handleFullscreenChange); // IE/Edge

    // Clean up event listeners on component unmount
    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
      document.removeEventListener(
        "mozfullscreenchange",
        handleFullscreenChange
      );
      document.removeEventListener(
        "webkitfullscreenchange",
        handleFullscreenChange
      );
      document.removeEventListener(
        "MSFullscreenChange",
        handleFullscreenChange
      );
    };
  }, []);

  const enterFullscreen = () => {
    const elem = document.documentElement; // Fullscreen for entire document
    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.mozRequestFullScreen) {
      elem.mozRequestFullScreen();
    } else if (elem.webkitRequestFullscreen) {
      elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) {
      elem.msRequestFullscreen();
    }
  };

  const handleFSButtonClick = () => {
    enterFullscreen();
  };

  return (
    <Container fluid className="app-container">
      {finished ? (
        <div className="mt-5">
          <h1>Result</h1>
          <p>Here are your results for the {data?.module} mock test:</p>
          {score != 0 && <p>Band: {band}</p>}
          <p>Score: {score}</p>
          <Button
            className="btn"
            color="primary"
            onClick={() => navigate("/home")}
          >
            Back to Home
          </Button>
        </div>
      ) : (
        <>
          {isStarted ? (
            <>
              {isFullscreen ? (
                <Row className="main-row">
                  <Col xs={12} md={8} className="pdf-col">
                    {/* <iframe
            src={data?.file?.Location}
            title="PDF Viewer"
            width="100%"
            height="100%"
            style={{ border: "none" }}
          /> */}
                    <PDFViewContainer url={data?.file?.Location} />
                  </Col>
                  <Col xs={12} md={4} className="options-col">
                    <h2>Time left: {formatTime(timeLeft)}</h2>
                    <div className="options-container">
                      {/* Render your quiz options here */}
                      {questions.map((_, i) => (
                        <div key={i} className="question-block d-flex">
                          <p className="mr-2">
                            <strong>{i + 1}</strong>{" "}
                          </p>
                          {options.map((option) => (
                            <div
                              key={option}
                              className="option-container ml-1"
                              onClick={() => handleOptionSelect(i, option)}
                            >
                              {/* <input
                      type="radio"
                      id={`q${i}opt${option}`}
                      name={`q${i}`}
                      value={option}
                      checked={selectedOption[i] === option}
                      onChange={(e) => handleOptionSelect(e, i, option)}
                    /> */}
                              <label
                                htmlFor={`q${i}opt${option}`}
                                className={`option-label`}
                              >
                                <div className="option-text">{option}</div>
                                <div
                                  className={`option-indicator ${
                                    selectedOptions[i] === option
                                      ? "selected"
                                      : ""
                                  }`}
                                ></div>
                              </label>
                            </div>
                          ))}
                        </div>
                      ))}
                      <div className="text-center">
                        <Button
                          outline
                          color="primary"
                          className="mt-3 mb-5"
                          onClick={handleSubmit}
                        >
                          Submit
                        </Button>
                      </div>
                    </div>
                  </Col>
                </Row>
              ) : (
                <div className="mt-5">
                  <h1>You need to be in full screen mode!</h1>
                  <br />
                  <Button color="primary" onClick={enterFullscreen}>
                    Back to Full Screen
                  </Button>
                </div>
              )}
            </>
          ) : (
            <div className="mt-5">
              <h1>When you are ready, press the button below:</h1>
              <br />
              <Button
                color="primary"
                onClick={() => {
                  setIsStarted(true);
                  startTimer();
                  enterFullscreen();
                }}
              >
                Start the Test
              </Button>
            </div>
          )}
        </>
      )}
    </Container>
  );
};

export default TKTMockPage;
